/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Discard_ConfirmInputs */

const en_us2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard`)
};

const pt_br2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const es_419_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const pt_pt2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar`)
};

const fr_fr2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer`)
};

const de_de2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwerfen`)
};

const it_it2_offline_discard_confirm = /** @type {(inputs: Offline_Discard_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scarta`)
};

/**
* | output |
* | --- |
* | "Discard" |
*
* @param {Offline_Discard_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_discard_confirm = /** @type {((inputs?: Offline_Discard_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Discard_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_discard_confirm(inputs)
	if (locale === "es-419") return es_419_offline_discard_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_discard_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_discard_confirm(inputs)
	if (locale === "de-DE") return de_de2_offline_discard_confirm(inputs)
	if (locale === "it-IT") return it_it2_offline_discard_confirm(inputs)
	return en_us2_offline_discard_confirm(inputs)
});
export { offline_discard_confirm as "offline.discard_confirm" }